module.exports = __webpack_public_path__ + "img/map-marker-alt.46caa3ba.svg";